module.exports = __webpack_public_path__ + "static/media/logo-horizontal.73447977.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-horizontal.svg
// module id = 789
// module chunks = 0